<template>
  <account-layout>
    <el-form :model="verifyForm" :rules="verifyRules" ref="verifyForm" @submit.native.prevent>
      <el-row :gutter="60">
        <el-col :span="24">
          <div class="su-title">Verify Your Account</div>
          <div class="su-sub-title">A verification code has been sent to your email address. Your verification code will expire in 60 minutes.</div>
        </el-col>
        <el-col :span="24" class="row-space">
          <div class="d-flex justify-content-between">
            <span>Verification Code</span>
          </div>
          <el-form-item prop="code">
            <el-input class="input-space" type="text" v-model="verifyForm.code" placeholder="Type here..." @keyup.enter.native="verify">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="errorMessage">
          <el-alert show-icon type="error" :title="errorMessage" :closable="false" />
        </el-col>
        <el-col :span="24" v-if="successMessage">
          <el-alert show-icon type="success" :title="successMessage" :closable="false" />
        </el-col>
      </el-row>
      <el-row class="row-space">
        <el-col :span="24">
          <el-button
            type="primary"
            class="ac-btn"
            @click="verify"
          >Verify Account</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24" class="align-center">
        Didn't receive code to your email?
        <el-button type="text" @click="resendCode()">Resend Code</el-button>
      </el-col>
    </el-row>
  </account-layout>
</template>

<script>
import AccountLayout from './AccountLayout.vue';

export default {
  name: 'AccountVerify',
  components: {
    AccountLayout
  },
  props: {
    platform: String
  },
  data() {
    return {
      user: {},
      errorMessage: '',
      codeSent: false,
      successMessage: '',
      verifyForm: {
        code: ''
      },
      verifyRules: {
        code: [
          { required: true, message: 'Verification code is required', trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    this.user = this.$store.state.user;
    if (this.$store.getters['user/isVerified']) {
      this.$router.push('dashboard');
    }
  },
  methods: {
    async verify() {
      this.errorMessage = '';
      this.successMessage = '';

      this.$refs.verifyForm.validate((valid) => {
        if (valid) {
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.post(`/assemble/api/v1/account/${this.platform}/verification/submit`, {
            code: this.verifyForm.code,
          }).then(async () => {
            this.$store.commit('user/verified');
            await this.$store.dispatch('national/setup');
            this.$router.push('dashboard').catch(() => {});
            this.$store.commit('loading', false);
          }).catch((e) => {
            this.errorMessage = e.response.data.message;
            this.$store.commit('loading', false);
          });
        }
      });
    },
    resendCode() {
      this.errorMessage = '';
      this.successMessage = '';

      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.post(`/assemble/api/v1/account/${this.platform}/verification/resend`, {
        method: 'email',
        type: 1
      }).then(() => {
        this.successMessage = 'Verification code has been sent to your email. Your verification code will expire in 60 minutes.';
        this.codeSent = true;
        this.$store.commit('loading', false);
      }).catch((e) => {
        this.errorMessage = e.response.data.message;
        this.$store.commit('loading', false);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.content-card {
  margin-left: 1em;
  margin-right: 1em;
  margin-top: 2em;
  width: 90%;
  max-width: 30em;
}

.su-title {
  text-align: center;
  font-size: 1.5em;
}

.su-sub-title {
  font-size: 0.85em;
  margin-bottom: 1em;
  font-family: $fontLight;
  white-space: normal;
  text-align: center;
  margin-top: 1em;
}

.align-center {
  text-align: center;
}

.row-space {
  margin-top: 1em;
}

.input-space {
  margin-top: 0.5em;
}

.ac-btn {
  width: 100%;
  background-color: $highlight !important;
  border: 0;
}
.text-button{
  color: $primary;
  cursor: pointer;
  &:hover {
    color: $highlight;
  }
}
.description {
  font-size: 0.85em;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  color: $highlight;
}
</style>
